<template>
  <div class="block container py-24 sm:py-48 xxl:px-24">
    <div class="lg:flex -mx-12">
      <div
        v-for="block in component.blocks"
        :key="block.id"
        class="px-12 w-full mb-24 last:mb-0 sm:last:mb-0 sm:mb-32 lg:mb-0"
      >
        <div
          class="rounded-xl min-h-380 overflow-hidden relative sm:min-h-410 md:min-h-556"
          :style="{ 'background-color': block.color }"
        >
          <nuxt-img
            v-if="block.image && block.background_type == 'image'"
            :src="clearImgUrl(block.image)"
            preset="standard"
            :sizes="imageSize"
            alt="Blockbild"
            class="absolute top-0 left-0 object-cover object-center h-full w-full rounded-xl"
          />

          <video
            v-if="block.video && block.background_type == 'video'"
            class="absolute top-0 left-0 w-full h-full object-cover rounded-xl"
            autoplay
            muted
            loop
            playsinline
            :poster="clearImgUrl(block.image)"
          >
            <source :src="block.video" type="video/mp4">
          </video>

          <a
            v-if="block.button"
            :href="block.button.url"
            :target="block.button.target"
            class="
              btn btn--lg
              absolute
              bottom-24
              sm:bottom-32
              md:bottom-40
              left-1/2
              transform
              -translate-x-1/2
              w-fit-content
            "
            :class="{
              'btn--primary': block.button_color_theme === 'blue-theme',
              'btn--danger': block.button_color_theme === 'red-theme',
              'btn--secondary btn--ghost':
                block.button_color_theme === 'transparent-theme',
            }"
          >
            {{ block.button.title }}
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import ComponentBlock from '~/models/component-block';

import { defineComponent } from 'vue';

export default defineComponent({
  props: {
    component: {
      type: ComponentBlock,
      required: true,
    },
  },
  computed: {
    imageSize() {
      if (this.component.blocks.length === 3) {
        return 'mob375:100vw mob390:100vw mob414:100vw desk:425px';
      }
      if (this.component.blocks.length === 2) {
        return 'mob375:100vw mob390:100vw mob414:100vw desk:643px';
      }
      return 'mob375:100vw mob390:100vw mob414:100vw desk:1324px';
    },
  },
  methods: {
    clearImgUrl(url:string) {
      const urlPart = url.split('?');
      return urlPart[0];
    },
  },
});
</script>

<style>
.editorial-promo {
  &--full-width {
    @screen sm {
      @apply w-full;
    }

    @screen lg {
      @apply min-h-680;
    }

    .btn {
      @screen md {
        @apply bottom-112;
      }
    }
  }
  &--3-col {
    &:last-of-type {
      @screen sm {
        @apply w-full;
      }
      @screen lg {
        @apply min-h-680;
      }
      .btn {
        @screen md {
          @apply bottom-112;
        }
      }
    }
  }
}
</style>
